
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import React, { useEffect, useState } from 'react'
import { useStore } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { wrapper } from 'tennders-common/stores/store'
import 'public/css/swiper-bundle.min.css'
import 'styles/style.scss'
import '@/styles/globals.scss'
import 'styles/datepicker.scss'
import 'styles/multipleItemPicker.scss'
import 'styles/SearchFilter.scss'
import 'styles/Tabs.scss'
import 'tennders-common/form/styles/phoneNumber.scss'
import 'tennders-price-simulator/styles/price-simulator.scss'
import NextNProgress from 'nextjs-progressbar'
import LoaderGIF from 'tennders-market/common/components/element/LoaderGIF'
import { isDesktop } from 'react-device-detect'
import { GButton } from 'tennders-common/form/components'
import useTranslation from 'next-translate/useTranslation'
import styles from '@/styles/Login.module.scss'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { config } from '@fortawesome/fontawesome-svg-core'

config.autoAddCss = false
function MyApp({ Component, pageProps }) {
  const store = useStore()
  const { t } = useTranslation('auth')
  const [isUserAcceptedLogin, setIsUserAcceptedLogin] = useState(false)

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-underscore-dangle
  const persistor = process.browser ? store.__persistor : store

  useEffect(() => {
    if (!isDesktop) {
      document.body.style.minWidth = 'unset'
      document.body.classList.remove('tennders-custom-scroll')
      document.body.style.overflow = 'hidden'
    }
  }, [isDesktop])

  return (
    isDesktop || isUserAcceptedLogin
      ? (
        <PersistGate persistor={persistor} loading={<LoaderGIF />}>
          <NextNProgress color="#DBB222" startPosition={0.3} stopDelayMs={200} height={3} showOnShallow options={{ showSpinner: false }} />
          <Component {...pageProps} />
        </PersistGate>
      )
      : (
        <div className={styles['tennders-login-mobile']}>
          <div className={styles['tennders-login']} style={{ padding: 50, borderRadius: 0 }}>
            <div className={styles['tennders-login-white-box']}>
              <h3 className="d-flex w-100 justify-center mb-0">{t('not_mobile_compatible')}</h3>
              <div className="d-flex justify-center mt-24">
                <GButton
                  className="btn standard-btn"
                  onClick={() => setIsUserAcceptedLogin(true)}
                >
                  {t('login_anyway')}
                </GButton>
              </div>
            </div>
          </div>
        </div>
      )
  )
}

const __Page_Next_Translate__ = wrapper.withRedux(MyApp)


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: false,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  